import { z } from 'zod'

const nodeEnv = z.enum(['development', 'production', 'test'])

const envSchema = z.object({
  MODE: nodeEnv,
  VITE_BACKEND_URL: z.string().nonempty(),
  VITE_FLAGSMITH_ID: z.string().nonempty(),
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_PRIVACY_POLICY_URL: z.string().url(),
  VITE_RECAPTCHA_ENABLED: z
    .string()
    .default('true')
    .transform((val) => val === 'true'),
  VITE_RECAPTCHA_SITE_KEY: z.string().nonempty(),
  VITE_DASHBOARD_URL: z.string().nonempty(),
})

export const ENV = envSchema.parse(import.meta.env)
